/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Compass, FileSearch, Users } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-20 bg-ivory">
      <Seo
        title="Page introuvable (404)"
        description="La page que vous recherchez n'existe pas ou a été déplacée. Retrouvez le Vérificateur, notre réseau de spécialistes ou l'orientation guidée."
        canonical="/404"
        noindex
      />
      <div className="max-w-2xl mx-auto text-center" data-testid="page-404">
        <p className="text-[10px] uppercase tracking-[0.32em] text-copper mb-3">Erreur 404</p>
        <h1 className="font-serif italic text-5xl sm:text-6xl text-night leading-[1.05] mb-5">
          Cette page n'existe pas.
        </h1>
        <p className="text-base text-night/75 max-w-xl mx-auto leading-relaxed mb-10">
          La page que vous recherchez n'existe pas ou a été déplacée. Voici quelques pistes pour reprendre votre navigation.
        </p>

        <div className="grid sm:grid-cols-3 gap-4 mb-10 text-left">
          <Link to="/verifier" className="p-5 rounded-sm border border-sage bg-paper hover:border-copper transition-smooth" data-testid="404-link-verifier">
            <FileSearch className="w-5 h-5 text-copper mb-3" />
            <p className="text-sm font-semibold text-night mb-1">Vérificateur CONFILEX</p>
            <p className="text-[12px] text-night/60">Analyse factuelle d'un document.</p>
          </Link>
          <Link to="/orientation" className="p-5 rounded-sm border border-sage bg-paper hover:border-copper transition-smooth" data-testid="404-link-orientation">
            <Compass className="w-5 h-5 text-copper mb-3" />
            <p className="text-sm font-semibold text-night mb-1">Orientation guidée</p>
            <p className="text-[12px] text-night/60">Trouver le spécialiste adapté.</p>
          </Link>
          <Link to="/our-experts" className="p-5 rounded-sm border border-sage bg-paper hover:border-copper transition-smooth" data-testid="404-link-experts">
            <Users className="w-5 h-5 text-copper mb-3" />
            <p className="text-sm font-semibold text-night mb-1">Notre réseau</p>
            <p className="text-[12px] text-night/60">Avocats, experts-comptables, notaires.</p>
          </Link>
        </div>

        <Button asChild className="rounded-sm bg-petrol text-ivory hover:bg-night px-8 py-3" data-testid="404-back-home">
          <Link to="/"><ArrowLeft className="w-4 h-4 mr-2" /> Retour à l'accueil</Link>
        </Button>
      </div>
    </main>
  );
}
